var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "text_input--container",
      class: _vm.containerClasses,
      style: { "--click-position": _vm.clickPosition },
    },
    [
      _vm.type === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currentValue,
                expression: "currentValue",
              },
            ],
            ref: "input",
            attrs: { disabled: _vm.disabled, name: _vm.name, type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.currentValue)
                ? _vm._i(_vm.currentValue, null) > -1
                : _vm.currentValue,
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", _vm.currentValue)
              },
              mousedown: _vm.mouseDownHandler,
              focus: _vm.focusHandler,
              blur: _vm.blurHandler,
              change: function ($event) {
                var $$a = _vm.currentValue,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.currentValue = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.currentValue = $$c
                }
              },
            },
          })
        : _vm.type === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currentValue,
                expression: "currentValue",
              },
            ],
            ref: "input",
            attrs: { disabled: _vm.disabled, name: _vm.name, type: "radio" },
            domProps: { checked: _vm._q(_vm.currentValue, null) },
            on: {
              input: function ($event) {
                return _vm.$emit("input", _vm.currentValue)
              },
              mousedown: _vm.mouseDownHandler,
              focus: _vm.focusHandler,
              blur: _vm.blurHandler,
              change: function ($event) {
                _vm.currentValue = null
              },
            },
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currentValue,
                expression: "currentValue",
              },
            ],
            ref: "input",
            attrs: { disabled: _vm.disabled, name: _vm.name, type: _vm.type },
            domProps: { value: _vm.currentValue },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.currentValue = $event.target.value
                },
                function ($event) {
                  return _vm.$emit("input", _vm.currentValue)
                },
              ],
              mousedown: _vm.mouseDownHandler,
              focus: _vm.focusHandler,
              blur: _vm.blurHandler,
            },
          }),
      _vm._v(" "),
      _vm.label.length
        ? _c("span", { staticClass: "text_input--label" }, [
            _vm._v(_vm._s(_vm.label)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.errorMsg.length
        ? _c(
            "span",
            {
              staticClass: "text_input--error",
              on: {
                click: _vm.errorClickHandler,
                animationend: _vm.errorAnimationEndHandler,
              },
            },
            [
              _vm.errorIcon
                ? _c(
                    "span",
                    { staticClass: "text_input--error_icon material-icons" },
                    [_vm._v(_vm._s(_vm.errorIcon))]
                  )
                : _vm._e(),
              _vm._v("\n    " + _vm._s(_vm.errorMsg) + "\n  "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "date" || _vm.type === "month"
        ? _c("a", {
            staticClass:
              "text_input--date_clear material-icons tooltip-dock_left",
            attrs: { href: "#", "data-tooltip": "Clear" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.dateClearClickHandler.apply(null, arguments)
              },
            },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }